﻿$.fn.dxCtrlBuilderEmailStyleAlignement = function custom_dxCtrlBuilderEmailStyleAlignement(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstylealignement dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleAlignement(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStyleAlignement = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        var ds = ["Gauche", "Centre", "Droite","Justifié"]
        if (option.allowDefaut) ds.unshift("Défaut")
        $("<div/>").appendTo(container).dxCtrlRadioButton({
            dataSource: ds,
            value: ((option.value == "left") ? "Gauche" : ((option.value == "right") ? "Droite" : ((option.value == "center") ? "Centre" : ((option.value == "justify") ? "Justifié" : "Défaut")))),
            layout: 'horizontal',
            itemTemplate: function (itemData, itemIndex, itemElement) {
                if (itemData == "Défaut") {
                    itemElement.html("<i class='fas fa-text-slash'></i>")
                    itemElement.attr("title", "Utiliser le style par défaut")
                } else {
                    itemElement.text(itemData)
                    itemElement.attr("title", itemData)
                }
            },
            onValueChanged: function (e) {
                var newValue = ""
                switch (e.value) {
                    case "Défaut": newValue = ""; break;
                    case "Gauche": newValue = "left"; break;
                    case "Centre": newValue = "center"; break;
                    case "Droite": newValue = "right"; break;
                    case "Justifié": newValue = "justify"; break;
                }
                option.onValueChanged({ values: [{ prop: "text-align", value: newValue, oldValue: option.value }] })
                option.value = newValue
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}